var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttPositionBased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 27,
    viewBox: "0 0 84 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5615 -8627)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4873 8048)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 27,
    rx: 13.5,
    transform: "translate(742 579)",
    opacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M711.919,1304.242a7.021,7.021,0,0,0-6.852,5.581h-3.924a5.117,5.117,0,0,0-9.843,0h-5.838a5.128,5.128,0,0,0-9.86,0h-3.908a7.029,7.029,0,1,0,0,2.8h3.892a5.132,5.132,0,0,0,9.892,0h5.806a5.121,5.121,0,0,0,9.875,0h3.908a6.993,6.993,0,1,0,6.852-8.38Zm-43.1,8.38a4.228,4.228,0,1,1-.032-2.8,3.891,3.891,0,0,1,.258,1.431A4.273,4.273,0,0,1,668.815,1312.622Zm13.607,0a2.318,2.318,0,0,1-3.764,0,2.326,2.326,0,0,1,3.716-2.8,2.279,2.279,0,0,1,.5,1.431A2.256,2.256,0,0,1,682.422,1312.622Zm15.681,0a2.317,2.317,0,0,1-3.763,0,2.25,2.25,0,0,1-.451-1.368,2.332,2.332,0,0,1,4.664,0A2.25,2.25,0,0,1,698.1,1312.622Zm13.816,2.83a4.178,4.178,0,0,1-3.957-2.83,4.058,4.058,0,0,1,.016-2.8,4.2,4.2,0,1,1,3.941,5.629Z",
    transform: "translate(4968.153 7328.758)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttPositionBased);
export default __webpack_public_path__ + "static/media/att-position-based.f3803e102741b2e3d897aa9b17f0c47e.svg";
export { ForwardRef as ReactComponent };